import PreservedLink from '@/components/shared/PreservedLink'
import CTAButton from '@/components/shared/CTAButton'

const LenderLinksSection = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const lenders = [
    { name: 'Alphera Finance', url: '/lenders/mis-sold-alphera-car-finance' },
    { name: 'Audi Finance', url: '/lenders/mis-sold-audi-car-finance' },
    { name: 'Barclays Finance', url: '/lenders/mis-sold-barclays-car-finance' },
    { name: 'BMW Finance', url: '/lenders/mis-sold-bmw-car-finance' },
    { name: 'Mercedes Finance', url: '/lenders/mis-sold-mercedes-car-finance' },
    { name: 'Santander', url: '/lenders/mis-sold-santander-car-finance' },
    { name: 'Toyota Finance', url: '/lenders/mis-sold-toyota-car-finance' },
    {
      name: 'Volkswagen Finance',
      url: '/lenders/mis-sold-volkswagen-car-finance',
    },
  ]

  return (
    <section
      className="py-12 md:py-16"
      style={{ backgroundColor: 'rgba(25, 135, 84, 0.1)' }}
    >
      <div className="container mx-auto max-w-6xl px-4">
        <h2
          className="mb-6 text-3xl font-bold"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          Claim Mis-sold Car Finance By Lender
        </h2>

        <p
          className="mb-8 text-lg leading-relaxed"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          We process claims for all major car finance providers listed below.
          You could be owed thousands in compensation, so don&apos;t miss the
          opportunity to check your eligibility.
        </p>

        <div className="mb-8 grid grid-cols-2 gap-4 md:grid-cols-4">
          {lenders.map(lender => (
            <PreservedLink
              key={lender.url}
              to={lender.url}
              onClick={scrollToTop}
              className="bg-card border-foreground group rounded-lg border-2 p-4 text-center transition-all duration-300 hover:scale-105 hover:shadow-lg"
            >
              <span
                className="font-semibold"
                style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
              >
                {lender.name}
              </span>
            </PreservedLink>
          ))}
        </div>

        <div className="text-center">
          <CTAButton />
        </div>
      </div>
    </section>
  )
}

export default LenderLinksSection
